"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var actions_1 = require("../../utils/actions");
var actions_2 = require("./actions");
exports.initialState = {
    emailAddress: '',
    telephoneNumber: '',
    cartId: '',
    taxExempt: null,
    taxId: '',
    schoolName: '',
    schoolWebsite: '',
    isComplete: false,
};
var setContact = function (state, action) {
    var contact = action.payload.contact;
    return __assign(__assign({}, state), contact);
};
var setContactField = function (state, action) {
    var _a;
    var _b = action.payload, fieldName = _b.fieldName, value = _b.value;
    return __assign(__assign({}, state), (_a = {}, _a[fieldName] = value, _a));
};
var setContactIsComplete = function (state, action) {
    var isComplete = action.payload.isComplete;
    return __assign(__assign({}, state), { isComplete: isComplete });
};
var clearContactFields = function () {
    return exports.initialState;
};
var contactReducer = function (stateFromStore, action) {
    if (stateFromStore === void 0) { stateFromStore = exports.initialState; }
    var state = stateFromStore || exports.initialState;
    if ((0, actions_1.isType)(action, actions_2.setContactAction)) {
        return setContact(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setContactFieldAction)) {
        return setContactField(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setContactIsCompleteAction)) {
        return setContactIsComplete(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearContactFieldsAction)) {
        return clearContactFields();
    }
    else {
        return state;
    }
};
exports.default = contactReducer;
